<template>
  <div>
    <div style="text-align: center mt-5 mb-3">
      <h1 class="mt-5">FAQs</h1>
    </div>
    <h3 @click="show1 = !show1">1) How do I place my order with AamCart?</h3>
    <div v-if="show1">
      <h4>Simply WhatsApp us your order at +91 9718058249</h4>
    </div>
    <h3 @click="show2 = !show2">
      2) How do I know the list and rates of items available at AamCart for
      ordering?
    </h3>
    <div v-if="show2">
      <h4>
        WhatsApp us at +91 9718058249 and ask for the list and price of
        available items. The items list changes may have minor changes because
        of the supply chain disruptions owing to CoVID 19 situation in
        respective farmer/ supplier areas.
      </h4>
    </div>
    <h3 @click="show3 = !show3">
      3) How much time does AamCart takes for delivery?
    </h3>
    <div v-if="show3">
      <h4>
        We have a committed order delivery time of 4 hours from receipt of
        confirmed order, however in most cases we are able to delivery much
        earlier.
      </h4>
    </div>
    <h3 @click="show4 = !show4">4) How can I pay?</h3>
    <div v-if="show4">
      <h4>
        AamCart supports and promotes e-payments via use of any of the wallets –
        PayTM, GPay, PhonePe, IMPS and accepts payment via all these modes.
      </h4>
    </div>
    <h3 @click="show5 = !show5">
      5) What if the quality of any of the products is not good?
    </h3>
    <div v-if="show5">
      <h4>
        AamCart takes due precautions and has stringent quality control
        processes while packing for each of its orders. However, should there
        still be a slip, AamCart offers you to raise a complain within two hours
        of your receiving the delivery of your order. Send a picture of the
        product that you are not satisfied with and it would be resolved to your
        satisfaction.
      </h4>
    </div>
    <h3 @click="show6 = !show6">6) Why should I order from AamCart?</h3>
    <div v-if="show6">
      <ul>
        <li>
          <h4>
            AamCart brings to your plate the produce directly sourced from the
            farmers besides the cold storages (for non-seasonal fruits) that
            allow warehouse receipts to farmers. Our endeavor remains to respect
            our AamCarts (farmers) and pay them fairly, while bringing the
            produce that's grown with responsible cultivation practices.
            #AamCartCares
          </h4>
        </li>
        <li>
          <h4>
            But that's not all: We have different and dedicated teams for each
            of our processes to minimize the possibility of spread of the CoVID
            19 virus, stringent quality processes to ensure that the processes
            further eliminate the possibility of any quality issues.
          </h4>
        </li>
        <li>
          <h4>
            We send a pair of gloves with each of our orders to enable you to
            handle and wash the items in your order to ensure that it need not
            be left in quarantine which, given the ambient temperature quickly
            deteriorates the quality of fruits and vegetables.
          </h4>
        </li>
      </ul>
    </div>
    <h3 @click="show7 = !show7">
      7) Do you have a wallet( subscription)scheme and can I pay in advance?
      What are the benefits of using the wallet scheme?
    </h3>
    <div v-if="show7">
      <h4>
        Yes, we do have a wallet scheme where you can top up your wallet with an
        amount of your choice and we keep adjusting the order amount and send
        the balance updates. The benefit is that it helps us expedite the
        dispatch process where we don't have to wait to collect the payment
        before dispatching the order.
      </h4>
    </div>
    <h3 @click="show8 = !show8">8) Why are you charging delivery charges ?</h3>
    <div v-if="show8">
      <h4>
        The current economic scenario and migration of workers has led to
        increase in the cost by our delivery partners. We also do same day ( 4
        hour delivery) and incur a huge cost for it and we have only shifted a
        minor part of this cost , an amount of Rs 30 to our customers
        irrespective of the distance.
      </h4>
    </div>
    <h3 @click="show9 = !show9">9) Is there a minimum order ?</h3>
    <div v-if="show9"><h4>It is 299 only</h4></div>
    <h3 @click="show10 = !show10">10) What time can I order ?</h3>
    <div v-if="show10">
      <h4>
        You can order 24/7. Order received til 6 pm is processed and delivered
        the same day . All orders received after 6 pm are processed the
        following day on a first come basis.
      </h4>
    </div>
    <h3 @click="show11 = !show11">
      11) What if I do not see a item on the list
    </h3>
    <div v-if="show11">
      <h4>
        Let us know a day in advance and we will attempt to procure it for you .
      </h4>
    </div>
    <h3 @click="show12 = !show12">
      12) Is there an app to order?
    </h3>
    <div v-if="show12" class="mb-5">
      <h4>
        Our app is in beta testing phase and will be launched shortly. In the
        interim we are processing orders via WhatsApp
      </h4>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      show6: false,
      show7: false,
      show8: false,
      show9: false,
      show10: false,
      show11: false,
      show12: false
    };
  }
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Anton&family=Lalezar&family=Lobster&family=Merriweather:wght@900&family=Play&display=swap");
h1 {
  font-size: 30px;
  text-align: center;
}
h3 {
  color: black;
  margin-left: 5%;
  margin-right: 10%;
}
h4 {
  color: navy;
  font-size: 16px;
  margin-left: 8%;
  margin-right: 10%;
}
li {
  color: navy;
  font-size: 12px;
  margin-left: 8%;
  margin-right: 10%;
}
</style>
